import styled from 'styled-components'
import { media } from '../utils/media'

export const IntakeInfoBar = styled.div`
  min-height: 70px;
  background: #133E66;
  margin-top: env(safe-area-inset-top);
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 10;

  h1 {
    margin: 14px 0 0;
    text-align: center;
    font-family: Nunito;
    font-size: 20px;
    font-weight: 900;
    color: #FFFFFF;

    ${media.tablet`
      margin: 11px 0 0;
      text-align: left;
      margin-left: 30px;
      font-size: 32px;
    `}

    ${media.desktop`
      margin: 11px 0 0;
      text-align: center;
    `}
  }

  p {
    margin-bottom: 12px;
    text-align: center;
    font-family: Nunito;
    font-size: 12px;
    font-weight: 500;
    color: #657684;

    ${media.tablet`
      position: absolute;
      top: 21px;
      right: 36px;
      font-size: 18px;
    `}
  }
`



// WEBPACK FOOTER //
// ./src/molecules/IntakeInfoBar.tsx